module.exports = __webpack_public_path__ + "static/media/bee.48e6f84b.png";